// extracted by mini-css-extract-plugin
export var actions = "_2o-0";
export var actionsContainer = "_2o-7";
export var border = "_2o-1";
export var childFullHeight = "_2o-f";
export var collapse = "_2o-2";
export var content = "_2o-a";
export var contentChild = "_2o-e";
export var fullscreen = "_2o-c";
export var hasLeftRadius = "_2o-k";
export var headerContainer = "_2o-3";
export var headerRow = "_2o-5";
export var hidePadding = "_2o-b";
export var navCollapsedGap = "_2o-l";
export var noScrollX = "_2o-m";
export var noScrollY = "_2o-n";
export var noTopPadding = "_2o-i";
export var optOutTopPadding = "_2o-d";
export var pageMain = "_2o-j";
export var pageOuter = "_2o-g";
export var pagePadding = "_2o-8";
export var pageScroll = "_2o-9";
export var profile = "_2o-o";
export var profileContainer = "_2o-p";
export var profileImage = "_2o-q";
export var profileMain = "_2o-r";
export var profileSubtitle = "_2o-t";
export var profileTitle = "_2o-s";
export var showLeftPadding = "_2o-h";
export var tabsPortalSlot = "_2o-6";
export var tabsWrapper = "_2o-4";
export var title = "_2o-u";